// extracted by mini-css-extract-plugin
export default {"title":"LodgingRoomCategoryDetails_title__L9rHO","edit":"LodgingRoomCategoryDetails_edit__WTBl6","cancel":"LodgingRoomCategoryDetails_cancel__sASwU"};